import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Badge, Typography} from "antd";
import { Icon } from '@ant-design/compatible';

import {NotificationFirebaseService} from "../../services/firebase/NotificationFirebaseService";

function ChatMenu({ menu, onClick }) {
  const [notification, setNotification] = useState({});

  useEffect(() => {
    const listener = NotificationFirebaseService()
      .listenAdminNotification(adminNotification => setNotification(adminNotification))

    return () => listener()
  }, []);

  return (
    <React.Fragment>
      <Link onClick={() => onClick(menu)} to={menu.url}>
        <Icon style={{ fontSize: 20 }} type={menu.icon} />
        <Badge dot={notification.notReadConversationIds && notification.notReadConversationIds.length > 0}>
          <Typography.Text className="mr-15 white">{menu.text}</Typography.Text>
        </Badge>
      </Link>
    </React.Fragment>
  )
}

export default ChatMenu
